/**
 * Created by wangjianglong on 2017/2/6.
 */
import Vue from 'vue';
let bus = new Vue();
export default bus;



// WEBPACK FOOTER //
// ./src/vendor/eventbus.js